import { apiRequest } from "../services/apiUtils";

/**
 * 产品信息接口
 */
export interface Product {
  id: number;
  name: string;
  priceFen: number;
  elderCount?: number; // 老人数量
}

/**
 * 产品服务类
 */
class ProductsService {
  /**
   * 获取基础服务产品列表
   */
  async getBasicServiceProducts(): Promise<Product[]> {
    const response = await apiRequest<{ data: Product[] }>(
      "/api/v1/products/basic-services",
      "GET"
    );
    return response.data;
  }
}

export const productsService = new ProductsService();
